import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";
import { paymetSchema, PaymentDto } from "../payment";

export const paymentAttemptSchema = z.object({
  id: z.string(),
  date: z.coerce.date(),
  providerId: z.string().nullable(),
  intendid: z.string(),
  status: z.number(),
});

export const paymentAttenptSchemaWithIntendSchema = paymentAttemptSchema.extend({
  intend: paymetSchema,
});

export class PaymentAttemptDto extends createZodDto(paymentAttemptSchema) {}
export class PaymentAttenptSchemaWithIntend extends createZodDto(
  paymentAttenptSchemaWithIntendSchema,
) {}
